import { type MaybeRefOrGetter, toValue } from 'vue';

export default function useCallNumber({
    displayNumber,
    clientSide,
    description = 'تماس با پشتیبانی',
}: {
    displayNumber: MaybeRefOrGetter<string>;
    description?: string;
    clientSide?: boolean;
}) {
    const { isDesktop } = useSize();
    const { $info } = useNotify();
    const isClicked = ref(false);
    const callNumber = computed(() =>
        toValue(displayNumber).replace('0', '+98').replace('-', '')
    );
    const href = computed(() => `tel:${callNumber.value}`);
    const onClick = () => {
        if (clientSide && !isDesktop.value) {
            window.open(href.value);
        }
        if (isClicked.value || !isDesktop.value) {
            return;
        }
        isClicked.value = true;
        copyTextToClipboard(callNumber.value);
        $info('در کلیپ‌بورد کپی شد!');
        window.setTimeout(() => {
            isClicked.value = false;
        }, 5000);
    };
    const displayTitle = computed(() =>
        isClicked.value ? toValue(displayNumber) : description
    );
    const element = computed(() => (isDesktop.value ? 'div' : 'a'));
    return {
        element,
        displayTitle,
        onClick,
        href: !clientSide && !isDesktop.value ? href.value : undefined,
    };
}
